module.exports = __webpack_public_path__ + "media/src/images/top_covers/2021_jan_05-01af57dee472e9f4459987207ac3ce6c.jpg";